import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    selectAllTextTemplate, selectTextTemplateEntities, selectTextTemplateFetched,
    selectTextTemplateLatestUpdatedAt,
    TEXT_TEMPLATE_KEY,
    TextTemplateState,
} from '../reducers/text-template.reducer';




const selectState = createFeatureSelector<TextTemplateState>(TEXT_TEMPLATE_KEY);

export const getTextTemplateDictionary = createSelector(selectState, selectTextTemplateEntities);
export const getTextTemplate = createSelector(selectState, selectAllTextTemplate);
export const getTextTemplateFetched = createSelector(selectState, selectTextTemplateFetched);
export const getTextTemplateLatestUpdatedAt = createSelector(selectState, selectTextTemplateLatestUpdatedAt);

export const getTextTemplateById = (props: { id: number }) => createSelector(getTextTemplateDictionary, (dictionary) => props?.id && dictionary[props.id]);
